import {
  ADD_CAMERA,
  IS_ANNOTATION,
  CHECK_IMAGE,
  CAMERA_DATA,
  ZONE_DATA,
  SELECTED_CAMERA,
  NEW_ZONES,
  SHOW_ZONE_INPUT,
  POLYGON_DETAILS,
  SAVED_POLYGONS,
  VIDEO_PLAYING
} from './actions';

export const initialState = {
  addCamera: false,
  isAnnotation: false,
  checkImage: false,
  cameraData: {
    store_name: 'Seawoods Nexus Mall',
    device_name: '',
    camera_address: '',
    active: '',
    process_skip_frame: 0
  },
  zoneData: {},
  selectedCamera: {},
  polygonDetials: {},
  savedPolygons: [],
  mode: '',
  videoPlaying: false
};

const cameraReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_CAMERA:
      return {
        ...state,
        addCamera: action.payload.addCamera,
        mode: action.payload.mode
      };
    case IS_ANNOTATION:
      return {
        ...state,
        isAnnotation: action.isAnnotation
      };
    case CHECK_IMAGE:
      return {
        ...state,
        checkImage: action.checkImage
      };
    case CAMERA_DATA:
      return {
        ...state,
        cameraData: action.cameraData
      };
    case ZONE_DATA:
      return {
        ...state,
        zoneData: action.zoneData
      };
    case SELECTED_CAMERA:
      return {
        ...state,
        selectedCamera: action.selectedCamera
      };
    case NEW_ZONES:
      return {
        ...state,
        newZones: action.newZones
      };
    case SHOW_ZONE_INPUT:
      return {
        ...state,
        showZoneInput: action.showZoneInput
      };
    case POLYGON_DETAILS:
      return {
        ...state,
        polygonDetails: action.polygonDetails
      };
    case SAVED_POLYGONS:
      return {
        ...state,
        savedPolygons: action.savedPolygons
      };
    case VIDEO_PLAYING:
      return {
        ...state,
        videoPlaying: action.videoPlaying
      };
    default:
      return state;
  }
};
export default cameraReducer;
